/** User-facing copy shown when the request-level MFA gate blocks a request. */
export const MFA_REQUIRED_MESSAGE = 'MFA verification required.';

/**
 * True when an API error is the backend's request-level MFA-gate denial:
 * HTTP 403 with `mfa_required: true`.
 *
 * The shape matches what the hey-api error interceptor produces
 * (`attachHttpStatusToError`): the JSON response body spread with an added
 * numeric `status`. Kept dependency-free (no router/app imports) so the router
 * error boundary can import it without creating an import cycle.
 */
export const isMfaRequiredError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') {
    return false;
  }
  const candidate = error as { status?: unknown; mfa_required?: unknown };
  return candidate.status === 403 && candidate.mfa_required === true;
};
